<template>
  <div class="coupon">
    <md-tabs
      ref="tabs"
      class="coupon-tab"
      v-model="activeName"
    >
      <md-tab-pane name="available" :label="titles[0]">
        <coupon-list status="available" :couponList="couponListAvailable"></coupon-list>
      </md-tab-pane>
      <md-tab-pane name="used" :label="titles[1]">
        <coupon-list status="used" :couponList="couponListUsed"></coupon-list>
      </md-tab-pane>
      <md-tab-pane name="expired" :label="titles[2]">
        <coupon-list status="expired" :couponList="couponListExpired"></coupon-list>
      </md-tab-pane>
    </md-tabs>
  </div>
</template>

<script>
import { Tabs, TabPane, Button } from 'mand-mobile'
import CouponList from '@/components/user/ticket/CouponList'

export default {
  i18n: {
    messages: {
      en: {
        available: 'Available',
        used: 'Used',
        expired: 'Expired',
      },
      id: {
        available: 'Tersedia',
        used: 'Terpakai',
        expired: 'Berakhir',
      },
    },
  },
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Button.name]: Button,
    CouponList,
  },
  data() {
    return {
      activeName: 'available',
      couponList: {
        available: [],
        used: [],
        expired: [],
      },
    }
  },
  computed: {
    titles() {
      return [
        `${this.$t('available')} (${this.couponListAvailable.length})`,
        `${this.$t('used')} (${this.couponListUsed.length})`,
        `${this.$t('expired')} (${this.couponListExpired.length})`,
      ]
    },
    couponListAll() {
      console.log(this.$store.state.couponList)
      return this.$store.state.couponList
    },
    couponListAvailable() {
      return this.couponListAll.UN_USE || []
    },
    couponListUsed() {
      return this.couponListAll.USED || []
    },
    couponListExpired() {
      return this.couponListAll.EXPIRED || []
    },
  },
  mounted() {
    this.$store.dispatch('reloadCouponList')
  },
  methods: {},
}
</script>

<style scoped lang="stylus">
.coupon-tab /deep/ {
  .md-tab-bar {
    height: 46px !important;
  }
  .md-tab-bar-inner {
    .md-tab-bar-item {
      font-size: 12px !important;
      &.is-active {
        color: #303133;
      }
    }
    .md-tab-bar-ink {
      height: 0;
    }
  }
  .md-tabs-content {
    background-color: #f0f2f5;
    padding-bottom: 20px;
    min-height: calc(100vh - 234px);
  }
}
</style>
